import { DuplicateRecordsForId, DuplicateSelectionsMap } from '@amzn/awscat-portfolio-assessment-types';
import { useCollection } from '@amzn/awsui-collection-hooks';
import { Box, Cards, Pagination, Toggle } from '@amzn/awsui-components-react';
import React, { FunctionComponent, useState } from 'react';

import { constants } from '../../../../common/Localization';
import { DEFAULT_PAGE_SIZE } from '../../../../common/table/constants';
import { DuplicateRecordsMap, PropertiesConfigMap } from '../common-util/types';
import { DuplicateCardForId } from './DuplicateCardForId';

interface Props {
    duplicateSelectionsMap: DuplicateSelectionsMap;
    onDuplicateSelectionsChange: (duplicateSelectionsMap: DuplicateSelectionsMap) => void;
    duplicateRecordsMap: DuplicateRecordsMap;
    propertiesConfigMap: PropertiesConfigMap;
}

const CARDS_PER_ROW = [
    { cards: 1 },
];

/**
 * A Cards component that displays all duplicate records in this import
 */
const DuplicateCards: FunctionComponent<Props> = function (props) {
    const [diffOnly, setDiffOnly] = useState(false);

    const cardDefinition = {
        header: (item: DuplicateRecordsForId) => item.id,
        sections: [
            {
                content: (item: DuplicateRecordsForId) => DuplicateCardForId(
                    props.duplicateSelectionsMap,
                    props.onDuplicateSelectionsChange,
                    props.duplicateRecordsMap[item.id],
                    item.id,
                    props.propertiesConfigMap,
                    diffOnly),
                id: 'duplicate-card',
            },
        ],
    };
    const items: DuplicateRecordsForId[] = Object.values(props.duplicateRecordsMap)
        .filter((duplicateRecordsForId: DuplicateRecordsForId) => {
            return duplicateRecordsForId.id && duplicateRecordsForId.records?.length > 0;
        });

    const { paginationProps } = useCollection(items, {
        pagination: { pageSize: DEFAULT_PAGE_SIZE },
    });
    const onToggle = (e: any) => {
        setDiffOnly(e.detail.checked);
    };
    const toggle = (
        <Box float='right'>
            <Toggle
                checked={diffOnly}
                onChange={onToggle}
            >
                {constants.VIEW_ONLY_DIFFERENCES_TOGGLE}
            </Toggle>
        </Box>
    );
    const header = (
        <h2>{`${constants.DUPLICATE_RECORDS_TITLE} `}
            <span className='awsui-util-header-counter'>({items.length})</span>
            <span>{toggle}</span>
        </h2>
    );

    return (
        <Cards
            id='duplicate-cards'
            cardDefinition={cardDefinition}
            items={items}
            cardsPerRow={CARDS_PER_ROW}
            header={header}
            pagination={<Pagination {...paginationProps}></Pagination>}
        />
    );
};

export default DuplicateCards;
